import { queryOptions } from '@tanstack/react-query';

import type {
  BookingCoverageCandidatesQueryParams,
  BookingCoverageCandidatesResponse,
  BookingGroupSessionCoverageCandidatesQueryParams,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingCoverageCandidateKeys = {
  all: () => ['bookingCoverageCandidates'] as const,
  list: (props: BookingCoverageCandidatesQueryParams) =>
    [
      ...bookingCoverageCandidateKeys.all(),
      'list',
      props.url,
      props.reservationId,
      props.clientId,
    ] as const,
  groupSession: (props: BookingGroupSessionCoverageCandidatesQueryParams) =>
    [
      ...bookingCoverageCandidateKeys.all(),
      'groupSession',
      props.url,
      props.groupSessionId,
      props.clientId,
    ] as const,
};

export const bookingCoverageCandidateQueries = {
  list: (props: BookingCoverageCandidatesQueryParams) =>
    queryOptions({
      queryKey: bookingCoverageCandidateKeys.list(props),
      queryFn: () =>
        HttpClient.request<BookingCoverageCandidatesResponse>({
          method: 'GET',
          url: `${props.url}/${props.reservationId}/coverage_candidates`,
          params: { client_id: props.clientId },
        }),
      enabled: !!props.url && !!props.reservationId,
      refetchOnWindowFocus: false,
      gcTime: 0,
      staleTime: 0,
    }),
  groupSession: (props: BookingGroupSessionCoverageCandidatesQueryParams) =>
    queryOptions({
      queryKey: bookingCoverageCandidateKeys.groupSession(props),
      queryFn: () =>
        HttpClient.request<BookingCoverageCandidatesResponse>({
          method: 'GET',
          url: `${props.url}/${props.groupSessionId}/coverage_candidates`,
          params: { client_id: props.clientId },
        }),
      enabled: !!props.url && !!props.groupSessionId && !!props.clientId,
      refetchOnWindowFocus: false,
      gcTime: 0,
      staleTime: 0,
    }),
};
